import { useEffect } from 'react'
import { Platform } from 'react-native'
import { UserServices } from '../../../../database/user.database'
import { useFooterApp } from '../../../redux/zustand/footerAppStore'

/**
 * Hook para inicializar footer_app en web
 * Extrae la lógica de inicialización de TabsNavigation para uso independiente
 */
export const useFooterAppInitializer = () => {
    const footer_app = useFooterApp((state) => state.footer_app)
    const setFooterApp = useFooterApp((state) => state.setFooterApp)

    useEffect(() => {
        const initializeFooterApp = async () => {
            // Solo ejecutar en web
            if (Platform.OS !== 'web') {
                return
            }

            try {
                console.log('[useFooterAppInitializer] 🔄 Inicializando footer_app para web...')
                console.log('[useFooterAppInitializer] Estado actual del store:', footer_app ? `${footer_app.length} items` : 'null')
                
                // SIEMPRE hacer el fetch desde IndexedDB, no confiar en el store
                // Esto asegura que cada usuario vea su propio menú
                const res_get_footer_app = await UserServices.getFooterApp()
                console.log('[useFooterAppInitializer] footer_app recibido desde IndexedDB:', res_get_footer_app ? res_get_footer_app.length : 0, 'items')

                if (res_get_footer_app && res_get_footer_app.length > 0) {
                    console.log('[useFooterAppInitializer] ✅ Guardando footer_app en store:', res_get_footer_app.map(i => i.label))
                    setFooterApp(res_get_footer_app)
                } else {
                    console.warn('[useFooterAppInitializer] ⚠️ No se recibieron datos válidos desde IndexedDB')
                    setFooterApp([])
                }
            } catch (error) {
                console.error('[useFooterAppInitializer] ❌ Error inicializando footer_app:', error)
                setFooterApp([])
            }
        }

        initializeFooterApp()
    }, [setFooterApp]) // Removido footer_app de las dependencias para evitar re-ejecuciones innecesarias

    return {
        footer_app,
        isLoaded: footer_app && footer_app.length > 0
    }
}